module.exports = __webpack_public_path__ + "img/test2.9df45a1c.png";